/**
 * Google Maps configuration (frontend).
 *
 * This is the FRONTEND (browser) key only. It is referrer-restricted and scoped
 * to the Maps JavaScript API + Places API (New) by Terraform
 * (terraform/google-maps). It is safe to ship in the client bundle.
 *
 * Do NOT use the backend/server key here — that key is IP-restricted to the EC2
 * hosts and is used server-side for Place Details + Address Validation.
 *
 * Set REACT_APP_GOOGLE_MAPS_API_KEY in the environment (.env files) to enable
 * address autocomplete. If unset, the address field falls back to a plain text
 * input with no suggestions.
 */

export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const isGoogleMapsConfigured = () => Boolean(googleMapsApiKey);
